import {createGetAllMethod} from "../core/factory";
import {entityType} from "./module";

export const getAllMyPermissions = () => createGetAllMethod(entityType)